import {Injectable} from '@angular/core';
import {FileService} from './file.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AdminService {

    constructor(private http: HttpClient, private fileService: FileService) {
    }

    exportReferentiel(callback?) {
        this.http.get(`${environment.apiUrl}/referentiel/export`).subscribe((res: any) => {
            this.fileService.download(res.id);
            if (typeof callback === 'function') {
                callback();
            }
        });
    }

    getImportUrl() {
        return `${environment.apiUrl}/referentiel/import`;
    }

    forceDataRefresh(callback?) {
        this.http.post(`${environment.managementUrl}/refresh-data`, null).subscribe(() => {
            if (typeof callback === 'function') {
                callback();
            }
        });
    }
}
